/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FormHistory,
    FormHistoryFromJSON,
    FormHistoryFromJSONTyped,
    FormHistoryToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface FormHistoriesListResponse
 */
export interface FormHistoriesListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof FormHistoriesListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<FormHistory>}
     * @memberof FormHistoriesListResponse
     */
    entries: Array<FormHistory>;
}

export function FormHistoriesListResponseFromJSON(json: any): FormHistoriesListResponse {
    return FormHistoriesListResponseFromJSONTyped(json, false);
}

export function FormHistoriesListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormHistoriesListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(FormHistoryFromJSON)),
    };
}

export function FormHistoriesListResponseToJSON(value?: FormHistoriesListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(FormHistoryToJSON)),
    };
}


